// The project's total embodied carbon and carbon intensity (both excluding stage D) are
// shown in two places: ProjectContext derives them from last-saved server state for use
// across the app, and step 8 of the wizard (AddProjectEmbodiedCarbonReporting) derives
// them from live, unsaved form values so the figures update per keystroke without
// routing unsaved edits through context. Both call sites must use the exact same maths,
// or the wizard could display a different total than the rest of the app persists/shows.

export interface EmbodiedCarbonGwpFields {
  a1_a3_gwp_kg: number | null;
  a4_gwp_kg: number | null;
  a5_gwp_kg: number | null;
  b1_b5_gwp_kg: number | null;
  c1_c4_gwp_kg: number | null;
}

export interface SmqCarbonSubtotals {
  Substructure: number;
  Superstructure: number;
}

// a1_a3_gwp_kg !== null is a strict null check on purpose: 0 is a real reported value
// and must be used as-is, not treated as unset and replaced by the SMQ subtotals.
export const calculateEmbodiedCarbon = (
  details: EmbodiedCarbonGwpFields,
  subtotals: SmqCarbonSubtotals
): number => {
  const { a1_a3_gwp_kg, a4_gwp_kg, a5_gwp_kg, b1_b5_gwp_kg, c1_c4_gwp_kg } = details;
  let total = 0;

  if (a1_a3_gwp_kg !== null) {
    total = a1_a3_gwp_kg;
  } else {
    total = subtotals.Substructure + subtotals.Superstructure;
  }

  total += (a4_gwp_kg ?? 0) + (a5_gwp_kg ?? 0) + (b1_b5_gwp_kg ?? 0) + (c1_c4_gwp_kg ?? 0);

  return total;
};

// d_gwp_kg is deliberately excluded from the total (the UI labels say "excluding D").
export const calculateCarbonIntensity = (
  totalEmbodiedCarbon: number,
  grossAreaSqft: number | null
): number => {
  if (!grossAreaSqft) return 0;
  return totalEmbodiedCarbon / (grossAreaSqft * 0.092903);
};
